import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  message,
  Typography,
  Tag,
  Modal as ModalB,
} from "antd";
import Highlighter from "react-highlight-words";
import ReactExport from "react-export-excel";

//Floating Buttons
import FloatingButtons from "react-floating-buttons";
import moneyl from "../../../../assets/icons/cash.svg";
import moneyf from "../../../../assets/icons/cash-multiple.svg";

// Excel Render
import { ExcelRenderer } from "react-excel-renderer";

//Iconos y constantes
import {
  SearchOutlined,
  FilePdfOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

import Icon from "@mdi/react";
import { mdiCalendarClock } from "@mdi/js";

//Componentes propios de detalle y actualizacion
import ModalApp from "../../../Modal";
import CST from "../../../../utils/CustomSettings";
import CjbGastosLcl from "./CjbGastosLcl";
import CjbGastosFrn from "./CjbGastosFrn";
import DetalleGastos from "./DetalleGastos";

//Importaciones para el uso de Redux
import { useSelector } from "react-redux";

//Importaciones y componentes propios
import { showNotification } from "../../../../utils/ShowNotification";
import FRM from "../../../../utils/FrmService";
import curStyle from "../../../../css/GlobalCmp.module.css";
import { myNumber } from "../../../../utils/ArrayFunctions";
import { URL_FILES } from "../../../../constants";

//Estilos
import "./CjbGastosFrm.scss";
import { number } from "prop-types";

export default function CjbGastosFrm(props) {
  const { setIsLoading } = props;
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [widthModal, setWidthModal] = useState("70%");
  const [tipoModal, setTipoModal] = useState(1);
  const [detalleModal, setDetalleModal] = useState({});
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const [listGastos, setListGastos] = useState([]);
  const [stateInf, setStateInf] = useState(Math.random());
  const [totalLcl, setTotalLcl] = useState(0);
  const [totalFrn, setTotalFrn] = useState(0);
  const [downExcel, setDownExcel] = useState(false);
  const [tipoExcel, setTipoExcel] = useState(1);
  const [gastosLcl, setGastosLcl] = useState([]);
  const [gastosFrn, setGastosFrn] = useState([]);

  const { confirm } = ModalB;
  const { Title } = Typography;

  //Para uso de excel
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  //useSelector para acceder al store
  const currentUser = useSelector(
    (state) => state.currentUser.currentUser.user_data
  );

  const currentSetup = useSelector(
    (state) => state.rolEnviroment.rolEnviroment.utlsetup
  );

  const currentMoneda = useSelector(
    (state) => state.rolEnviroment.rolEnviroment.monedas
  );

  useEffect(() => {
    (async () => {
      setIsLoading(false);
      let datos = await FRM.getGastos(currentUser, 1);
      if (datos.type && datos.type > 0) {
        setListGastos(datos.listado);
        setTotalFrn(datos.num_rsm);
        setTotalLcl(datos.total_rsm);
        separaFact(datos.listado);
      } else {
        showNotification(
          "topRight",
          1,
          "FACTURAS DE PROVEEDOR",
          "No hay FACTURAS REGISTRADAS"
        );
      }
      setIsLoading(false);
    })();
  }, [stateInf]);

  const separaFact = (array) => {
    const newLcl = [];
    const newFrn = [];
    array.forEach((row) => {
      let item = {
        meg_id: row.meg_id,
        meg_fecha: row.meg_fecha,
        trc_nombre: row.trc_nombre,
        cnc_nombre: row.cnc_nombre,
        cls_nombre: row.cls_nombre,
        meg_detalle: row.meg_detalle,
        meg_importe: row.meg_importe,
      };

      if (Number.parseInt(row.meg_moneda) !== 1) {
        newLcl.push(item);
      } else {
        newFrn.push(item);
      }
    });
    setGastosLcl(newLcl);
    setGastosFrn(newFrn);
  };

  const openModal = (record, tipo, ancho) => {
    setTipoModal(tipo);
    setWidthModal(ancho);
    setDetalleModal(record);
    setIsVisibleModal(true);
  };

  const closeModal = () => {
    setIsVisibleModal(false);
  };

  const openAdjunto = (record) => {
    //Url para visaulizacion del PDF Temporal
    const url_temp =
      URL_FILES + currentUser.dominio + "/gastos/" + record.meg_adjunto;
    window.open(`${url_temp}`);
  };

  const downFactu = async (tipo, curArray) => {
    setTipoExcel(tipo);
    if (curArray.length > 0) {
      setDownExcel(true);
      setTimeout(function () {
        setDownExcel(false);
      }, 1000);
    } else {
      message.error("NO HAY DATOS PARA EXPORTAR", 1);
    }
  };

  //Aplazar gastos
  const aplGastos = async (gasto) => {
    //setIsLoading(true);
    message.info("APLZANDO LA FACTURA", 3);
    let record = {
      tipoMov: 6,
      meg_estado: 3,
      meg_id: gasto.meg_id,
      meg_numero: gasto.meg_numero,
      meg_moneda: gasto.meg_moneda,
      usr_apr: gasto.usr_apr,
    };
    var val_gasto = await FRM.sendGasto(currentUser, record);
    if (val_gasto.type && Number.parseInt(val_gasto.type) > 0) {
      //setStateInf(Math.random());
      showNotification("topRight", 4, "APLAZAR FACTURAS", "MOVIMIENTO EXITOSO");
      setStateInf(Math.random());
    } else {
      showNotification("topRight", 2, "APLAZAR FACTURAS", val_gasto.message);
    }
    //setIsLoading(false);
  };

  const deleRecord = async (record) => {
    confirm({
      title: "EILIMINAR PAGO A " + record.trc_nombre,
      icon: <ExclamationCircleOutlined />,
      okText: "ELIMINAR",
      cancelText: "Cancelar",
      content: "DESEA ELIMINAR EL GASTO?",
      onOk() {
        deleGastos(record);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  //Eliminar gastos
  const deleGastos = async (gasto) => {
    setIsLoading(true);
    let record = {
      tipoMov: 9,
      meg_estado: 5,
      meg_id: gasto.meg_id,
      meg_numero: gasto.meg_numero,
      meg_moneda: gasto.meg_moneda,
      usr_apr: gasto.usr_apr,
    };
    var val_gasto = await FRM.sendGasto(currentUser, record);
    if (val_gasto.type && Number.parseInt(val_gasto.type) > 0) {
      setStateInf(Math.random());
      showNotification("topRight", 4, "ELIMINAR GASTOS", "MOVIMIENTO EXITOSO");
    } else {
      showNotification("topRight", 2, "ELIMINAR GASTOS", val_gasto.message);
    }
    setIsLoading(false);
  };

  //Nuevas funciones de busqueda de columnas
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });
  //Fin de nuevas funciones de busqueda

  //Definicion de los floating
  const buttonsList = [
    {
      onClick: () => openModal(null, 1, "900px"),
      src: moneyl,
    },
    {
      onClick: () => openModal(null, 2, "900px"),
      src: moneyf,
    },
  ];
  //Fin floating

  //Columnas de la tabla
  const columns = [
    {
      title: "No",
      key: "action",
      width: 50,
      render: (text, record) => (
        <Button
          type="primary"
          className={curStyle.btnDanger}
          size="large"
          shape="circle"
        >
          {record.meg_numero}
        </Button>
      ),
    },
    {
      title: "FECHA", //10%
      dataIndex: "meg_fecha",
      key: "meg_fecha",
      width: 150,
      ...getColumnSearchProps("meg_fecha"),
    },
    {
      title: "BENEFICIARIO", //10%
      dataIndex: "trc_nombre",
      key: "trc_nombre",
      width: 350,
      ...getColumnSearchProps("trc_nombre"),
    },
    {
      title: "CONCEPTO",
      dataIndex: "cnc_nombre",
      key: "cnc_nombre",
      width: 350,
      ...getColumnSearchProps("cnc_nombre"),
    },
    {
      title: "CLASE",
      dataIndex: "cls_nombre",
      key: "cls_nombre",
      width: 350,
      ...getColumnSearchProps("cls_nombre"),
    },
    {
      title: "ESTADO",
      dataIndex: "meg_estado",
      key: "meg_estado",
      width: 100,
      render: (text, row, index) => {
        return row.meg_estado === 1 ? (
          <Tag color="cyan">POR PAGAR</Tag>
        ) : row.meg_estado === 2 ? (
          <Tag color="geekblue">POR DESEMBOLSO</Tag>
        ) : (
          <Tag color="volcano">DESEMBOLSADO</Tag>
        );
      },
    },
    {
      title: "USD$",
      dataIndex: "meg_importe",
      key: "meg_importe",
      align: "right",
      width: 150,
      render: (text, row, index) => {
        return row.meg_moneda === 1 ? (
          <Tag color="green" style={{ fontSize: 15 }}>
            {currentMoneda.simbolo + myNumber(1, row.meg_importe)}
          </Tag>
        ) : (
          <Tag color="green" style={{ fontSize: 15 }}>
            {currentMoneda.simbolo + myNumber(1, 0)}
          </Tag>
        );
      },
    },
    {
      title: "$ UYU",
      dataIndex: "meg_importe",
      key: "meg_importe",
      align: "right",
      width: 150,
      render: (text, row, index) => {
        return row.meg_moneda === 1 ? (
          <Tag color="orange" style={{ fontSize: 15 }}>
            {currentMoneda.simbolo + myNumber(1, 0)}
          </Tag>
        ) : (
          <Tag color="orange" style={{ fontSize: 15 }}>
            {currentMoneda.simbolo_frn + myNumber(1, row.meg_importe)}
          </Tag>
        );
      },
    },
    {
      title: "+",
      key: "action",
      width: 50,
      render: (text, record) => (
        <Button
          type="primary"
          className={curStyle.btnDanger}
          size="large"
          shape="circle"
          icon={<FilePdfOutlined />}
          onClick={() =>
            record.meg_adjunto
              ? openAdjunto(record)
              : message.error("NO HAY ARCHIVO ADJUNTO", 1)
          }
        />
      ),
    },
    {
      title: "+",
      key: "action",
      width: 50,
      render: (text, record) => (
        <Button
          type="primary"
          className={curStyle.btnSky}
          size="large"
          shape="circle"
          icon={<SearchOutlined />}
          onClick={() => openModal(record, 3, "900px")}
        />
      ),
    },
    {
      title: "+",
      key: "action",
      width: 50,
      render: (text, record) => (
        <Button
          type="primary"
          className={curStyle.btnWarning}
          size="large"
          shape="circle"
          onClick={() =>
            record.meg_estado === 1 || record.meg_estado === 3
              ? aplGastos(record)
              : message.error("EL GASTO YA ESTA APLICADO", 1)
          }
        >
          <Icon path={mdiCalendarClock} size={"23"} />
        </Button>
      ),
    },
    {
      title: "+",
      key: "action",
      width: 50,
      render: (text, record) => (
        <Button
          type="primary"
          className={curStyle.btnLila}
          size="large"
          shape="circle"
          icon={<DeleteOutlined />}
          onClick={() => deleRecord(record)}
        />
      ),
    },
  ];

  //Renderizacion del componente
  return (
    <div className="main-content">
      <Table
        columns={columns}
        dataSource={listGastos}
        style={{ padding: 3, marginTop: 5 }}
        scroll={{ x: 1500 }}
        summary={(pageData) => {
          return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={6}>
                  <Title level={4}>{"TOTALES FACTURAS USD$ Y UYU$"}</Title>
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                  <Title
                    level={4}
                    style={{
                      color: "green",
                      textAlign: "right",
                      marginLeft: 30,
                      marginTop: 15,
                      cursor: "pointer",
                    }}
                    onClick={() => downFactu(1, listGastos)}
                  >
                    {myNumber(1, totalLcl, 2)}
                  </Title>
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                  <Title
                    level={4}
                    style={{
                      color: "orange",
                      textAlign: "right",
                      marginLeft: 30,
                      marginTop: 15,
                      cursor: "pointer",
                    }}
                    onClick={() => downFactu(2, listGastos)}
                  >
                    {myNumber(1, totalFrn, 2)}
                  </Title>
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={4}></Table.Summary.Cell>
              </Table.Summary.Row>
            </>
          );
        }}
      />
      <ModalApp
        isVisibleModal={isVisibleModal}
        closeModal={closeModal}
        widthModal={tipoModal === 4 ? 1307 : widthModal}
      >
        {tipoModal === 1 ? (
          <CjbGastosLcl
            currentUser={currentUser}
            closeModal={closeModal}
            setStateInf={setStateInf}
            currentSetup={currentSetup}
            myNumber={myNumber}
          />
        ) : tipoModal === 2 ? (
          <CjbGastosFrn
            currentUser={currentUser}
            closeModal={closeModal}
            setStateInf={setStateInf}
            currentSetup={currentSetup}
            myNumber={myNumber}
          />
        ) : (
          <DetalleGastos
            currentUser={currentUser}
            closeModal={closeModal}
            setStateInf={setStateInf}
            currentSetup={currentSetup}
            myNumber={myNumber}
            detalleModal={detalleModal}
            currentMoneda={currentMoneda}
          />
        )}
      </ModalApp>
      {Number.parseInt(currentUser.tipo) === 4 ? (
        <FloatingButtons
          buttonType="plus"
          buttonColor={"#ffffff"}
          backgroundColor={CST.redBdy}
          dimension={60}
          buttonsList={buttonsList}
          top={"calc(90% - 25px)"}
          left={"120px"}
          direction="circular"
          degree={-180}
          distance={90}
        />
      ) : null}
      {downExcel ? (
        <ExcelFile
          filename={
            tipoExcel === 1 ? "FACTURAS EN DOLARES" : "FACTURAS EN PESOS"
          }
          hideElement={true}
        >
          <ExcelSheet
            data={tipoExcel === 1 ? gastosLcl : gastosFrn}
            name={tipoExcel === 1 ? "FACTURAS EN DOLARES" : "FACTURAS EN PESOS"}
          >
            <ExcelColumn label="NUMERO" value="meg_id" />
            <ExcelColumn label="FECHA" value="meg_fecha" />
            <ExcelColumn label="PROVEEDOR" value="trc_nombre" />
            <ExcelColumn label="CONCEPTO" value="cnc_nombre" />
            <ExcelColumn label="CLASE" value="cls_nombre" />
            <ExcelColumn label="DETALLE" value="meg_detalle" />
            <ExcelColumn label="IMPORTE" value="meg_importe" />
          </ExcelSheet>
        </ExcelFile>
      ) : null}
    </div>
  );
}
